import { isMl3App, isDeviceId } from 'modules/DeviceOptions';
import {
  SnsGood,
  SnsFollow,
  SnsCommentCreate,
  SnsCommentEdit,
  SnsCommentDelete
} from '../modules/API';
import Cookies from 'modules/Cookies';
import tmpls from 'modules/HandlebarsTemplates';

// いいね =======================================================
$(document).on('click', '.doSNSLike', e => {
  e.preventDefault();
  doSNSLike($(e.currentTarget));
});

$(document).on('click', '.ppvSNSLike', e => {
  e.stopPropagation();
  e.preventDefault();
  doSNSLike($(e.currentTarget));
});

const doSNSLike = async elem => {
  if (isMl3App && isDeviceId && !(window.Gdata.CurrentMap.ori[0] && (window.Gdata.CurrentMap.ori[0].template_id === window.MapClass.template.aliasMap || window.Gdata.CurrentMap.ori[0].template_id === window.MapClass.template.spotCollectionMap ))) {
    if (window.PhotoSwipeObj) {
      window.PhotoSwipeObj.close();
    }
    window.closeModal();
    setTimeout(() => {
      window.openModal('#mDeviceRegister');
    }, 400);
    return;
  }

  if (window.accountClass.checkPreviewer()) {
    return;
  }

  const id = elem.data('id');
  const elmType = elem.data('elmtype');

  if (!window.ObjsToUpdate[elmType]) {
    return;
  }

  let total = null;
  let state = false;

  _.forEach(window.ObjsToUpdate[elmType], elmList => {
    if (elmList && elmList.dic && elmList.dic[id]) {
      const elm = elmList.dic[id];
      if (total === null) {
        elm.reply_count = elm.reply_count || {};
        state = !(elm.user_reply && elm.user_reply.good);
        const { good = 0 } = elm.reply_count;
        total = state ? parseInt(good, 10) + 1 : parseInt(good, 10) - 1;
      }
      elm.reply_count.good = total;
      elm.user_reply = elm.user_reply || {};
      elm.user_reply.good = state;
    }
  });
  if (total > 0) {
    $('#showHeart' + id).attr('src', '/img/tmp/good_color.png');
  } else {
    $('#showHeart' + id).attr('src', '/img/tmp/good_line2.png');
  }

  SnsGood({
    session: Cookies.get('session') || 'NO_LOGIN',
    goodFrom: id,
    isDelete: !state,
    locale: window.hlocale
  });

  //button
  if (state) {
    $(`.domLikeToggle${elmType}${id}`).addClass('active');
  } else {
    $(`.domLikeToggle${elmType}${id}`).removeClass('active');
  }

  //text count
  total = total || 0;
  const domObjects = $(`.dataLikeCount${elmType}${id}`);

  domObjects.each((a, countElm) => {
    if ($(countElm).data('htmltemplate')) {
      $(countElm).html(
        $(countElm)
          .data('htmltemplate')
          .replace('{replace}', total)
      );
    } else {
      $(countElm).html(total);
    }
  });

  if (total === 0) {
    domObjects.addClass('hidden');
  } else {
    domObjects.removeClass('hidden');
  }
};

// フォロー =======================================================
$(document).on('click', '.doSNSFollow', async e => {
  e.preventDefault();

  if (isMl3App && isDeviceId && !(window.Gdata.CurrentMap.ori[0] && (window.Gdata.CurrentMap.ori[0].template_id === window.MapClass.template.aliasMap || window.Gdata.CurrentMap.ori[0].template_id === window.MapClass.template.spotCollectionMap ))) {
    window.openModal('#mDeviceRegister');
    return;
  }

  if (window.accountClass.checkPreviewer()) {
    return;
  }

  if (!Cookies.get('session')) {
    $('.btnLoginOpen').trigger('click');
    return;
  }

  if (Gdata.Profile.ori === null && !Gdata.Profile.ori._id) {
    //no user
    return;
  }

  const id = $(e.currentTarget).data('id');

  let total = null;
  let state = false;

  for (const entries of Object.entries(window.ObjsToUpdate.map)) {
    const maps = entries[1];
    if (maps && maps.dic && maps.dic[id]) {
      const map = maps.dic[id];

      if (Gdata.Profile.ori._id === map.account_id && !map.followmap_id) {
        //cannot follow own map
        return;
      }

      if (total === null) {
        map.reply_count = map.reply_count || {};
        state = !(map.user_reply && map.user_reply.follow);
        const { follow = 0 } = map.reply_count;
        total = state ? parseInt(follow, 10) + 1 : parseInt(follow, 10) - 1;

        //確認モーダル
        if (
          !state &&
          !confirm(
            window.resolveLang('ブックマークを解除します。よろしいですか？')
          )
        ) {
          return;
        }
      }
      map.reply_count.follow = total;
      map.user_reply = map.user_reply || {};
      map.user_reply.follow = state;
    }
  }

  await SnsFollow({
    session: Cookies.get('session'),
    followFrom: id,
    isDelete: !state,
    locale: window.hlocale
  });

  if (state) {
    $(`.domFollowToggleMapID${id}`).addClass('active');
  } else {
    $(`.domFollowToggleMapID${id}`).removeClass('active');
  }

  $(`.dataFollowCountMapID${id}`).html(total);

  // update My Map New
  window.APIGetMyMaps({
    htmlTemplate: 'myMapListInnerTemplate',
    force: 1
  });

  //profile page
  if (window.ProfilePage) {
    window.ProfilePage.reset();
  }
});

// コメント =======================================================
/**
@type {{
  [key: string]: {
    _id: string;
    text: string;
    comment_from: string;
    account_id: string;
    registration_datetime: string;
    update_datetime: string;
    session_account_id: string;
    account: object;
    parentObj: object;
    lang: object;
    lang_cache: object;
  }
}}
 */
const commentDic = {};

const initializeComments = (id, elm) => {
  const initialCommentsToShow = 3;

  // show comments
  let objList = null;
  if (elm === 'dialy') {
    objList = Gdata.CurrentDialies.dic[id];
  } else {
    objList = Gdata.CurrentSpots.dic[id];
  }

  const container = $(`.${elm}CommentContainerNew${id}`).not(
    '.allCommentsShown'
  );
  const shownContainer = $(`.${elm}CommentContainerNew${id}.allCommentsShown`);

  const openCommentLink = container.children('.openComment');

  if (objList && objList.comments && objList.comments.length > 0) {
    const commentContainer = container.children('.commentListContainer');
    const shownCommentContainer = shownContainer.children(
      '.commentListContainer'
    );
    window.PopulateUpdateDatetime(objList.comments);
    objList.comments.sort(window.sort_by('registration_datetime'));

    shownCommentContainer.html('');
    objList.comments.forEach(comment => {
      comment.session_account_id = objList.session_account_id;
      comment.parentObj = objList; // required for authorization
      shownCommentContainer.append(tmpls.CommentBlockTemplate(comment));
    });

    commentContainer.html('');

    let start = objList.comments.length - initialCommentsToShow;
    start = start < 0 ? 0 : start;
    for (let i = start; i < objList.comments.length; i++) {
      if (!objList.comments[i]) {
        break;
      }
      commentContainer.append(tmpls.CommentBlockTemplate(objList.comments[i]));

      commentDic[objList.comments[i]._id] = objList.comments[i];
    }

    // translate comments
    if (window.translateCollection) {
      window.translateCollection(objList.comments, 'reply');
    }
  } else {
    openCommentLink.hide();
  }

  if (
    !objList ||
    !objList.comments ||
    objList.comments.length <= initialCommentsToShow
  ) {
    openCommentLink.hide();
  } else {
    openCommentLink.html(
      `${window.resolveLang('すべてのコメント表示')}(${
        objList.comments.length
      })`
    );
    openCommentLink.show();
  }
};
window.initializeComments = initializeComments;

const doComment = async (commentInput, container) => {
  if (isMl3App && isDeviceId && !(window.Gdata.CurrentMap.ori[0] && (window.Gdata.CurrentMap.ori[0].template_id === window.MapClass.template.aliasMap || window.Gdata.CurrentMap.ori[0].template_id === window.MapClass.template.spotCollectionMap))) {
    window.openModal('#mDeviceRegister');
    return;
  }

  if (window.accountClass.checkPreviewer()) {
    return;
  }

  if (commentInput.val() === '' || !commentInput || !container) {
    commentInput.focus();
    return;
  }

  if (!Cookies.get(CookieSession)) {
    if (window.PhotoSwipeObj) {
      window.PhotoSwipeObj.close();
    }
    window.closeModal();
    setTimeout(() => {
      $('.btnLoginOpen').trigger('click');
    }, 400);
    return;
  }

  const id = container.data('id');
  const elm = container.data('elm');

  try {
    const registrationMoment = moment();
    const comment = await SnsCommentCreate({
      session: Cookies.get('session'),
      commentFrom: id,
      text: commentInput.val(),
      registration_datetime: registrationMoment.utc().format('YYYY-MM-DD HH-mm-ss')
    });

    comment.account = Gdata.Profile.ori;

    // Add new comment
    let objList = null;
    if (elm === 'dialy') {
      objList = Gdata.CurrentDialies.dic[id];
    } else {
      objList = Gdata.CurrentSpots.dic[id];
    }

    if (objList) {
      objList.comments = objList.comments || [];
      objList.comments.push(comment);

      commentInput.val('');

      initializeComments(id, elm);
    }

    if (window.setWceContentArt) {
      window.setWceContentArt($(commentInput));
    }
    if (elm === 'dialy') {
      $('.wallDialyLoading').show();
      $('#ArticleTemplateContainer').html('');
      setCurrentMap();
    }
  } catch (e) {
    // console.log(e);
  }
};

$(document).on('click', '.openComment', e => {
  e.preventDefault();

  const id = $(e.currentTarget)
    .parent()
    .data('id');
  const elm = $(e.currentTarget)
    .parent()
    .data('elm');

  //focus
  $(e.currentTarget)
    .parent()
    .children('.commentInputBlock')
    .children('.commentContainer')
    .children('div')
    .children('textarea')
    .focus();

  $(e.currentTarget)
    .parent()
    .addClass('allCommentsShown');

  initializeComments(id, elm);

  $(e.currentTarget).hide();
});

$(document).on('click', '.openCommentOptionPopup', e => {
  const { currentTarget } = e;
  const popup = $(currentTarget)
    .parent()
    .parent()
    .children('.optionPopup')[0];
  window.openPopup(popup, currentTarget);
});

$(document).on('keyup', '.doSNSCommentTextArea', e => {
  const { currentTarget } = e;
  const snsCommentSend = $(currentTarget)
    .parent()
    .children('.snsCommentSend');
  if ($(currentTarget).val()) {
    snsCommentSend.addClass('active');
  } else {
    snsCommentSend.removeClass('active');
  }
});

$(document).on('click', '.focusComment', e => {
  const articleCard = $(e.currentTarget)
    .parent()
    .parent()
    .parent()
    .parent()
    .parent()
    .parent();
  articleCard
    .children('.socialCommentContainer')
    .children('.commentInputBlock')
    .children('.commentContainer')
    .children('div')
    .children('textarea')
    .focus();
});

$(document).on('click', '.doSNSComment', e => {
  e.preventDefault();

  const { currentTarget } = e;

  doComment(
    $(currentTarget)
      .parent()
      .children('textarea'),
    $(currentTarget)
      .parent()
      .parent()
      .parent()
      .parent()
  );
});

let selectedEditCommentId = '';
$(document).on('click', '.editComment', e => {
  e.preventDefault();

  if (window.accountClass.checkPreviewer()) {
    return;
  }

  selectedEditCommentId = $(e.currentTarget).data('commentid');

  if (!commentDic[selectedEditCommentId]) {
    return;
  }

  $('#editCommentTextArea').val(commentDic[selectedEditCommentId].text);
  window.openModal('#EditCommentModal');
});
$(document).on('click', '#doEditCommentButton', async e => {
  e.preventDefault();

  if (window.accountClass.checkPreviewer()) {
    return;
  }

  const newText = $('#editCommentTextArea').val();
  const selectedComment = commentDic[selectedEditCommentId];

  if (newText && selectedComment && selectedComment.text !== newText) {
    $('#EditCommentModal').addClass('freeze');
    try {
      await SnsCommentEdit({
        session: Cookies.get('session'),
        commentId: selectedEditCommentId,
        text: newText
      });

      selectedComment.text = newText;
      selectedComment.lang = {};

      initializeComments(
        selectedComment.comment_from,
        selectedComment.parentObj.spot ? 'dialy' : 'spot'
      );
    } catch (error) {
      alert(window.resolveLang('エラーが発生しました。'));
    }
    $('#EditCommentModal').removeClass('freeze');
  }

  window.closeModal();
});

$(document).on('click', '.deleteComment', async e => {
  const { currentTarget } = e;
  e.preventDefault();

  if (window.accountClass.checkPreviewer()) {
    return;
  }

  if (!confirm(window.resolveLang('コメントを削除しますか？'))) {
    return;
  }

  const commentId = $(currentTarget).data('commentid');

  const container = $(currentTarget)
    .parent()
    .parent()
    .parent()
    .parent()
    .parent()
    .parent();
  const elmId = container.data('id');
  const elm = container.data('elm');

  //いらないけど残しとく
  $(`.commentBlock${commentId}`).remove();

  await SnsCommentDelete({
    session: Cookies.get('session'),
    _id: commentId
  });

  // Add new comment
  let objList = null;
  if (elm === 'dialy') {
    objList = Gdata.CurrentDialies.dic[elmId];
  } else {
    objList = Gdata.CurrentSpots.dic[elmId];
  }

  if (objList && objList.comments.length > 0) {
    for (let i = 0, length1 = objList.comments.length; i < length1; i++) {
      if (commentId === objList.comments[i]._id) {
        objList.comments.splice(i, 1);
        break;
      }
    }

    initializeComments(elmId, elm);
  }
});

// シェア =======================================================
$(document).on('click', '.doSNSShare', e => {
  const { currentTarget } = e;
  e.preventDefault();

  const map = Gdata.CurrentMap.ori ? Gdata.CurrentMap.ori[0] : {};

  let url = `${window.location.origin}/${window.historyObj.urlEnum.mapsConst}/${
    window.historyObj.urlEnum.archiveConst
  }/`;
  url += $(currentTarget).data('shareurl') || `${map._id}?hl=${window.hlocale}`;
  const title = $(currentTarget).data('title') || map.title;
  const image =
    $(currentTarget).data('image') ||
    `${
      window.ImageDomainURLRead
    }beta/2ffc7af154cd9c098f7aa6346981b8fc7c359395658d3c6668d6c8560d9c3d96/${
      map.image_id
    }%3Fsize%3D700`;
  const device = (MobileDevice.DeviceOS == 0) ? 'iOSShare' : 'androidShare'

  $('#ShareTemplateContainer').html(
    tmpls.ShareTemplate({
      shareurl: url,
      title,
      image,
      device
    })
  );

  window.openModal('#mShare');
});

$(document).on('click', '.fbShare', e => {
  const { currentTarget } = e;
  e.preventDefault();
  if (isMl3App) {
    window.location.href = `https://www.facebook.com/dialog/feed?%20app_id=924897417548499%20&display=popup&amp;caption=An%20example%20caption%20&link=${$(
      currentTarget
    ).data('shareurl')}&redirect_uri=${window.location.href}`;
  } else {
    window.FB.ui(
      {
        method: 'share',
        display: 'popup',
        href: $(currentTarget).data('shareurl'),
        redirect_uri: 'https://www.mplf.net'
      },
      () => {}
    );
  }
});
